// ./src/components/features/Events/RsvpStatusMultiSelect.tsx
//
// Reusable multi-select of guest response statuses (matches the API's
// EVENT_RSVP_STATUS). Used to gate question visibility, and reusable anywhere a
// set of RSVP statuses is chosen (filters, automations, exports…). Labels are
// guest-facing and neutral.

import React from 'react';
import { MultiSelectProps } from '@mantine/core';
import { MultiSelectField } from '@/components/generic';

// The options live in a pure module (guards read them); re-exported here for every existing import.
export { RSVP_STATUS_OPTIONS } from './rsvpStatusOptions';
import { RSVP_STATUS_OPTIONS } from './rsvpStatusOptions';

export type RsvpStatusMultiSelectProps = Omit<MultiSelectProps, 'data'>;

// It keeps Mantine's `onChange(values)` for its callers; on a phone MultiSelectField opens the full-screen picker.
export const RsvpStatusMultiSelect: React.FC<RsvpStatusMultiSelectProps> = ({ onChange, ...props }) => (
  <MultiSelectField data={RSVP_STATUS_OPTIONS} searchable clearable {...props} onChange={(_name, v) => onChange?.(v)} />
);
